export default __webpack_public_path__ + "static/media/gordita-regular.692ddcbd.woff";